import { 
    TimeContainer,
    TimeWrapper,
    IconWrapper,
    TextInfo,
    StatusChip,
    StatusDot
} from './style-component'
import ClockIcon from '@/assets/icons/hourglass-empty/hourglass-empty.svg/hourglass-empty.svg.component.svg';
import CalendarIcon from '@/assets/icons/calendar/calendar.svg';
import CheckIcon from '@/assets/icons/check-circle/check-circle.svg/check-circle.svg.component.svg';
import HourglassExpiredIcon from '@/assets/icons/hourglass-expired/hourglass-expired.svg';
import { TimeInfoProps } from './time-info-types';
import { STATUS_MESSAGES, CAMPAIGN_COMPLETED_MESSAGE } from '@/utils/statuses/time-info-status/time-info-status';
import { formatTimeRemaining, formatTimeString } from '@/utils/format-time/format-time';
import { CampaignStatus } from '@/types/campaign/campaign-status/campaign-status';
import { GiftOutlined } from '@ant-design/icons';
import React from 'react';

const getStatusIcon = (status: CampaignStatus) => {
    switch (status) {
        case 'pending_claim':
            return <GiftOutlined style={{ color: 'inherit' }}/>;
        case 'completed':
            return CheckIcon;
        case 'expired':
            return HourglassExpiredIcon;
        case 'inCourse':
            return ClockIcon;
        case 'comingUp':
            return CalendarIcon;
        case 'incourseWinning':
            return ClockIcon;
        case 'incourseLoosing':
            return ClockIcon;
        default:
            return ClockIcon;
    }
};

export const TimeInfo: React.FC<TimeInfoProps> = ({
    endDate,
    startDate,
    status = 'inCourse',
    isCampaign = false,
    isContest = false
}) => {
    const timeRemaining = formatTimeRemaining(endDate, startDate);
    const statusIcon = getStatusIcon(status);
    const formattedTime = formatTimeString(
        timeRemaining.days, 
        timeRemaining.hours, 
        timeRemaining.isStartDate
    );

    const renderTimeText = () => {
        if (status === 'comingUp') {
            return `${formattedTime} ${STATUS_MESSAGES[status]}`;
        }

        if (isContest) {
            switch (status) {
                case 'completed':
                case 'expired':
                    return isCampaign ? CAMPAIGN_COMPLETED_MESSAGE : STATUS_MESSAGES[status];
                case 'incourseWinning':
                case 'incourseLoosing':
                case 'inCourse':
                    return formattedTime;
                case 'pending_claim':
                    return STATUS_MESSAGES[status];
                default:
                    return STATUS_MESSAGES[status];
            }
        }

        switch (status) {
            case 'completed':
                return isCampaign ? CAMPAIGN_COMPLETED_MESSAGE : STATUS_MESSAGES[status];
            case 'expired':
                return STATUS_MESSAGES[status];
            case 'pending_claim':
                return STATUS_MESSAGES[status];
            case 'inCourse':
                return formattedTime;
            default:
                return formattedTime;
        }
    };

    return (
        <TimeContainer>
            <TimeWrapper>
                <IconWrapper $status={status}>
                    {React.isValidElement(statusIcon) && statusIcon}
                    {typeof statusIcon === "string" && <img 
                        src={statusIcon}
                        alt="time" 
                    />}
                </IconWrapper>
                <TextInfo $status={status} $isTime={status === 'inCourse' || status === 'incourseWinning' || status === 'incourseLoosing'}>
                    {renderTimeText()}
                </TextInfo>
                {(status === 'inCourse' || status === 'incourseWinning' || status === 'incourseLoosing') && (
                    <>
                        <StatusChip $status={status}>
                            <StatusDot $status={status} />
                        </StatusChip>
                        <TextInfo $status={status}>{STATUS_MESSAGES[status]}</TextInfo>
                    </>
                )}
            </TimeWrapper>
        </TimeContainer>
    );
};